<template>
  <div class="app">

    <AppHeader fixed>

      <!-- Not even sure what this one is??? -->
      <!-- <SidebarToggler class="d-lg-none" display="md" mobile /> -->

      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/mainlogo.svg" height="130%">
        <img class="navbar-brand-minimized" src="img/squarelogo.svg" height="88%">
      </b-link>

      <SidebarToggler class="d-lg-none" />

      

      <!-- Right aligned top bar area --> 
      <b-navbar-nav class="d-md-down-none ml-auto">
        <b-nav-item class="d-md-down-none">
          <!--<DefaultHeaderDropdown/>-->
        </b-nav-item>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
    </AppHeader>


    <!-- Main body -->
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="navItems"></SidebarNav>

        <bruit-io v-bind:config.prop="bruitConfig">
          <ul class="nav mb-3">
            <!-- <SidebarNavLabel name="  Feedback" icon="far fa-plus-square"/> -->
            <SidebarNavItem classes="hidden-cn">
              <a class="nav-label" href="#">
                <i class="far fa-plus-square" /> &nbsp;&nbsp;Feedback
              </a>
            </SidebarNavItem>

          </ul>
        </bruit-io>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>

      <main class="main" v-if="teamDataLoaded">

        <!-- Show the white selector bar if at least one of the selectors is enabled for a given page -->
        <div v-if="pagesWithTimeSelector.includes(currentPage) || pagesWithUserSelector.includes(currentPage)" class="w-auto bg-white d-flex justify-content-between" style="margin-bottom: 20px;">

          <!-- User & User Group selector -->
          <div v-if="pagesWithUserSelector.includes(currentPage)">

            <b-form inline>

              <b-dropdown :variant="filterTeammates.length > 0 ? 'success' : 'secondary'" id="usersdropdown" :text="filterTeammates.length + ' Users'" class="m-2" @shown="onUserFilterShown">
                <div style="width: 360px;">
                  <v-select 
                  label="real_name" 
                  :options="teammates"
                  :value="filterTeammates"
                  :multiple="true"
                  :clearable="true"
                  :searchable="true"
                  :close-on-select="false"
                  ref="userFilterSelector"
                  @input="teammatesSelected">
                    <template slot="option" slot-scope="option">
                      <img :src="option.avatar" class="img-avatar" style="height: 40px;"/>
                      {{ option.real_name }}
                    </template>
                  </v-select>
                </div>
              </b-dropdown>

              <b-dropdown :variant="filterGroups.length > 0 ? 'success' : 'secondary'" id="groupsdropdown" :text="filterGroups.length + ' Groups'" class="m-2" @shown="onUserGroupFilterShown">
                <div style="width: 400px;">
                  <v-select 
                  label="name" 
                  :options="groups"
                  :value="filterGroups"
                  :multiple="true"
                  :clearable="true"
                  :searchable="true"
                  :close-on-select="false"
                  ref="userGroupFilterSelector"
                  @input="groupsSelected">
                    <template slot="option" slot-scope="option">
                      <i class="fa fa-group font-4xl mr-3 p-1"/>
                      {{ option.name }}
                    </template>
                  </v-select>
                </div>
              </b-dropdown>

              &nbsp;&nbsp;&nbsp;

              <b-button  
                variant="primary"
                @click="updateFilters">
                  Apply Filter
              </b-button>

              <b-button v-if="filterUserIds.length > 0"
                style="margin-left: 20px;"
                variant="ghost-secondary"
                @click="clearFilters">
                  Clear Filter
              </b-button>

            </b-form>
          </div>
          <div v-else>
            <!-- Nothing shown, just here to satisfy the flexbox content-between positioning -->
          </div>

          <!-- Time selector -->
            <div v-if="pagesWithTimeSelector.includes(currentPage)">
              <b-button-toolbar style="margin-top: 10px; margin-bottom: 10px;">
              <b-form-radio-group @change="updateTimePeriod" class="mr-3" id="teamActivityRadiosBtn" buttons button-variant="outline-secondary" v-model="timePeriodSelected" name="timePeriodSelector">
                <b-form-radio class="mx-0" value="12h">12h</b-form-radio>
                <b-form-radio class="mx-0" value="Day">Day</b-form-radio>
                <b-form-radio class="mx-0" value="Week">Week</b-form-radio>
                <b-form-radio class="mx-0" value="2Weeks">2 Weeks</b-form-radio>
                <!-- <b-form-radio class="mx-0" value="Month">Month</b-form-radio> -->
              </b-form-radio-group>
            </b-button-toolbar>
          </div>
          <div v-else>
            <!-- Nothing shown, just here to satisfy the flexbox content-between positioning -->
          </div>

        </div>
        <div v-else class="w-auto" style="margin-bottom: 20px; padding: 8px;">
          <!-- No user/time selector, just an empty div for the margin-bottom -->
        </div>

        <!-- <Breadcrumb :list="list"/> -->


        <div class="container-fluid" id="dashboardContainerFluid">
          <template v-if="!bypassMinAgeEnabled && teamAge <= 60 * 60 * 8 && (currentRoute.name != 'Account' && currentRoute.name != 'User Groups')">
            <new-install :min-age="8" />
          </template>
          <template v-else>
            <router-view></router-view>
          </template>
          
        </div>
      </main>

      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div class="d-flex flex-row">
        <div class="mr-auto">
          
          <span class="ml-1">ChatAcuity &copy; 2020 DataFeast LLC.</span>
        </div>
        <div class="ml-4">
          &nbsp;
          <a href="#" @click="logout">Logout</a>
        </div>
      </div>
      
    </TheFooter>

  </div>
</template>





<script>
import moment from 'moment'
import Cookies from 'js-cookie'
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, SidebarNavItem, SidebarNavLabel, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb, } from '@coreui/vue'
// import { toggleClasses, sidebarCssClasses, validBreakpoints, checkBreakpoint } from '@coreui/vue'
// import toggleClasses from '@coreui/vue/shared/toggle-classes'
import DefaultAside from './DefaultAside'
import miniToastr from 'mini-toastr'
import DefaultHeaderDropdown from './DefaultHeaderDropdown'
import NewInstall from '../views/NewInstall'

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
}

var miniT = miniToastr.init({
  types: toastTypes,
})

export default {
  name: 'DefaultContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarNavItem,
    SidebarNavLabel,
    SidebarMinimizer,
    NewInstall
  },

  mounted: function() {
    // console.log(this.$children)
    // console.log(this.$refs)
    // this.$refs.userFilterSelector.open = true
    // this.$refs.userGroupFilterSelector.open = true
    // setTimeout(this.autoOpenFilterSelects, 1000);

    // console.log(this.$route)
  },

  data () {
    return {
      navItems: nav.items,

      timePeriodSelected: 'Day',
      trialRemainingWarningDays: 3,

      filterTeammates: [],  // container for the users picker
      filterGroups: [],  // container for the groups picker
      filterChanged: false,  // dashboards 'watch' this value and update their charts

      pagesWithTimeSelector: ['birdseye', 'messaging', 'onlinepresence', 'social', 'channeldetail', 'teammatedetail'],
      pagesWithUserSelector: ['messaging', 'onlinepresence', 'social', 'channeldetail'],

      bruitConfig: {
        apiKey: "d02f59c6-387a-41e5-bbca-70da92152904",
        labels:{
          title: "ChatAcuity Feedback",
          introduction: "We'd love to hear your thoughts - good or bad - so we can improve!"
        },
        form:[
          {
            label: "Feedback",
            type: "textarea",
            required: true
          },
          {
            id: "agreement",
            type: "checkbox",
            label: "I agree to send browser technical information to aid in troubleshooting issues",
            value: false
          }
        ],
        colors: {
          header: "#20a8d8"
        },
        elementToRenderSelector: "#dashboardContainerFluid",
        // screenshot: {
        //   maxWidth: 2000,
        //   maxHeight: 2000,
        //   imageType: "image/png",
        // }
      }
    }
  },

  watch: {
    teamDataLoaded: function(loaded, lastLoadedState) {

      if(loaded) {
        setTimeout(() => this.showUnmonitoredChannelsNotification(), 1000)

        if(this.currentPage != 'account') {
          setTimeout(() => this.$store.dispatch('updateBillingData', []), 1000)
        }
      }
    },
    billingDataLoaded: function(loaded, lastLoadedState) {
      // only show it if no subscriptions AND we haven't shown the alert AND they're not on account page
      if(loaded && this.billingData.subscriptions.length == 0 && !this.haveShownTrialAlert && this.currentPage != 'account') {
        // AND there's only 3 or less days left in their trial
        if(this.trialTimeRemaining <= this.trialRemainingWarningDays) {
          // don't show for beta customers!  ugly hack until there is a real prop
          if(this.teamInfo.id > 10) {
            miniToastr[toastTypes.error](
            'Your free trial is almost up!  Please consider subscribing on the Account dashboard to avoid any interruption to your service.', 
            'Reminder - Free Trial Expiring', 
            20000)

            this.$store.commit('haveShownTrialAlert', true)
          } else {
            console.log('suppressing trial warning for beta customer')
          }
        }
      }
    }
  },

  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    },

    teamDataLoaded() {
      return this.$store.getters.teamLoaded
    },
    teamInfo() {
      return this.$store.getters.teamInfo
    },
    teamChannels() {
      return this.$store.getters.teamChannels
    },
    teamChannelsMonitored() {
      return this.$store.getters.teamChannels.filter(chan => chan.mon == true)
    },
    teamChannelsUnmonitored() {
      return this.$store.getters.teamChannels.filter(chan => chan.mon == false)
    },
    currentPage() {
      return this.$store.getters.currentPage
    },
    currentRoute() {
      return this.$route
    },
    bypassMinAgeEnabled() {
      return 'bypassMinAge' in this.$route.query
    },

    billingData() {
      return this.$store.getters.billingData
    },
    billingDataLoaded() {
      return this.$store.getters.billingDataLoaded
    },
    haveShownTrialAlert() {
      return this.$store.getters.haveShownTrialAlert
    },
    trialTimeRemaining() {
      let created = moment.unix(this.teamInfo.joined)
      let trialEnds = created.add(15, 'd')  // 7 immediately shows 6 days remaining in dash
      let now = moment()

      let diff = trialEnds.diff(now, 'days')
      diff = Math.max(diff, 0)

      return diff
    },

    teammates() {
      return this.$store.getters.teamMembers
    },
    groups() {
      return this.$store.getters.teamGroups
    },
    filterUserIds() {
      return this.$store.getters.filterUserIds
    },

    teamAge() {
      if(this.teamDataLoaded) {
        let elapsed = moment().unix() - this.teamInfo.joined
        return elapsed
      } else {
        return 0
      }
    }
  },

  methods: {
    updateTimePeriod(period) {
      this.$store.commit('timePeriod', period)
    },

    teammatesSelected(value) {
      this.filterTeammates = value
      // console.log(this.filterTeammates)
    },
    groupsSelected(value) {
      this.filterGroups = value
      // console.log(this.filterGroups)
    },

    updateFilters() {
      let uids = this.filterTeammates.map(member => member.id)
      let uidsFromGroups = [...new Set(this.filterGroups.map(group => group.members).flat())]
      
      // now combine them
      let uniqueUids = [...new Set(uids.concat(uidsFromGroups))]
      console.log('Filter combined user set: ' + uniqueUids)
      this.$store.commit('filterUserIds', uniqueUids)
    },
    clearFilters() {
      this.filterTeammates = []
      this.filterGroups = []
      // this.$refs.userFilterSelector.value = []
      // this.$refs.userGroupFilterSelector.value = []
      this.$store.commit('filterUserIds', [])
    },

    autoOpenFilterSelects() {
      this.$refs.userFilterSelector.open = true
      this.$refs.userGroupFilterSelector.open = true
    },
    onUserFilterShown(bvEvt) {      
      this.$refs.userFilterSelector.open = true
      this.$refs.userFilterSelector.$refs.search.focus()
    },
    onUserGroupFilterShown(bvEvt) {
      this.$refs.userGroupFilterSelector.open = true
      this.$refs.userGroupFilterSelector.$refs.search.focus()
    },

    showUnmonitoredChannelsNotification() {
      let seen = Cookies.get('CAdashboardNotificationUnmonitoredChannelsSeen')

      if(seen === undefined 
        && this.teamChannels.length > 10 
        && this.teamChannelsMonitored.length <= (this.teamChannels.length * .25)) {
        miniToastr[toastTypes.info](
          'We\'ve noticed that a large percentage of your public channels are unmonitored.  If this is not intentional, you can invite ChatAcuity to additional channels on the Account dashboard.', 
          '', 
          20000)
        Cookies.set('CAdashboardNotificationUnmonitoredChannelsSeen', true, { expires: 1 })
      }
      
    },

    logout(e) {
      e.preventDefault()
      // console.log(this.$store.getters.authTokenCookieName)
      Cookies.remove(this.$store.getters.authTokenCookieName)
      window.location = this.$store.getters.websiteUrl
    }


  }
}
</script>
